import { Link, useLocation } from 'react-router-dom';

export default function Footer() {
  const location = useLocation();
  if (location.pathname.startsWith('/admin')) return null;

  return (
    <footer className="footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <h3>CareerQuess</h3>
          <p>Your trusted recruitment partner connecting talented professionals with top employers across India. We make hiring simple, fast, and effective.</p>
        </div>
        <div className="footer-col">
          <h4>Our Services</h4>
          <Link to="/services/placement">Placement Consultant</Link>
          <Link to="/services/hr">HR Consultant</Link>
          <Link to="/services/manpower">Manpower Recruitment</Link>
        </div>
        <div className="footer-col">
          <h4>For Seekers</h4>
          <Link to="/jobs">Current Openings</Link>
          <Link to="/post-resume">Post Your Resume</Link>
          <Link to="/about">About Us</Link>
          <Link to="/contact">Contact Us</Link>
        </div>
        <div className="footer-col">
          <h4>Contact</h4>
          <span>31A, Arawali Apartment,</span>
          <span>Sector 52, Noida UP 201301</span>
          <a href="tel:+917840009121">+91 78400 09121</a>
          <a href="mailto:info@careerquess.com">info@careerquess.com</a>
        </div>
      </div>
      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} CareerQuess. All rights reserved.
      </div>
    </footer>
  );
}
